import { render, staticRenderFns } from "./ResumeTemplates.vue?vue&type=template&id=2ecf2634&scoped=true&"
import script from "./ResumeTemplates.vue?vue&type=script&lang=ts&"
export * from "./ResumeTemplates.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ecf2634",
  null
  
)

export default component.exports